"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Cd: ['cd', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,9a3,3,0,1,0,3,3A3,3,0,0,0,12,9Zm0,4.5A1.5,1.5,0,1,1,13.5,12,1.5,1.5,0,0,1,12,13.5Z', 'M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z']],
  CdBox1: ['cd-box-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10,12a2,2,0,1,0,2-2A2,2,0,0,0,10,12Zm3,0a1,1,0,1,1-1-1A1,1,0,0,1,13,12Z', 'M12,20.5A8.5,8.5,0,1,0,3.5,12,8.51,8.51,0,0,0,12,20.5Zm5-9.055a.5.5,0,0,1-.5-.433A3.714,3.714,0,0,0,14,7.974a.5.5,0,0,1,.32-.947A4.712,4.712,0,0,1,17.5,10.879a.5.5,0,0,1-.429.562A.385.385,0,0,1,17,11.446ZM15,12a3,3,0,1,1-3-3A3,3,0,0,1,15,12ZM7.164,13.016a.5.5,0,0,1,.607.362,3.711,3.711,0,0,0,2.834,2.733.5.5,0,0,1-.105.989.632.632,0,0,1-.105-.01A4.709,4.709,0,0,1,6.8,13.624.5.5,0,0,1,7.164,13.016Z', 'M24,1.957A1.959,1.959,0,0,0,22.043,0H1.957A1.959,1.959,0,0,0,0,1.957V22.045A1.959,1.959,0,0,0,1.957,24H22.043A1.959,1.959,0,0,0,24,22.045ZM22,21.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z']],
  CdBox: ['cd-box', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.044,0H1.956A1.959,1.959,0,0,0,0,1.957V22.045A1.959,1.959,0,0,0,1.956,24H22.044A1.959,1.959,0,0,0,24,22.045V1.957A1.959,1.959,0,0,0,22.044,0ZM22,21.5a.5.5,0,0,1-.5.5H2V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M12,14a2,2,0,1,0-2-2A2,2,0,0,0,12,14Zm0-3a1,1,0,1,1-1,1A1,1,0,0,1,12,11Z', 'M12,20.5A8.5,8.5,0,1,0,3.5,12,8.51,8.51,0,0,0,12,20.5ZM12,9a3,3,0,1,1-3,3A3,3,0,0,1,12,9Z']],
  CdBroken: ['cd-broken', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.73.735a.509.509,0,0,0-.547.228L11.9,4.642a.5.5,0,0,0,.425.763h1.646a.5.5,0,0,1,.373.834L8.457,12.75a.5.5,0,0,1-.826-.545l2.483-4.087a.5.5,0,0,0-.453-.713H7.614a.5.5,0,0,1-.426-.76l3.227-5.283A.5.5,0,0,0,9.891.605a11.491,11.491,0,1,0,4.839.13ZM12,16.155a4.23,4.23,0,0,1-2.978-1.217.75.75,0,0,1,1.051-1.071A2.75,2.75,0,1,0,13.882,9.9a.75.75,0,1,1,1.029-1.092A4.25,4.25,0,0,1,12,16.155Z']],
  CdPartition: ['cd-partition', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,.5A11.5,11.5,0,1,0,23.5,12,11.5,11.5,0,0,0,12,.5ZM14.25,12A2.25,2.25,0,1,1,12,9.751,2.253,2.253,0,0,1,14.25,12ZM9.8,21.733a.458.458,0,0,1-.115-.014,9.933,9.933,0,0,1-7.406-7.405.5.5,0,0,1,.37-.6l5.368-1.278a.251.251,0,0,1,.2.034.248.248,0,0,1,.108.167,3.731,3.731,0,0,0,3.042,3.041.251.251,0,0,1,.2.3l-1.278,5.367A.5.5,0,0,1,9.8,21.733ZM21.349,10.289l-5.368,1.278a.252.252,0,0,1-.2-.035.248.248,0,0,1-.108-.166,3.733,3.733,0,0,0-3.042-3.042.251.251,0,0,1-.2-.3l1.278-5.368a.494.494,0,0,1,.6-.37,9.933,9.933,0,0,1,7.406,7.4A.5.5,0,0,1,21.349,10.289Z']],
  CdBurn: ['cd-burn', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.477,8.251a8.5,8.5,0,0,1,7.814,5.182.251.251,0,0,0,.419.067,5.392,5.392,0,0,0,1.324-3.65,7.515,7.515,0,0,0-2.265-5.271.5.5,0,0,0-.832.324,1.929,1.929,0,0,1-2.131,1.655A4.834,4.834,0,0,1,15.67,1a.5.5,0,0,0-.436-.746c-4.313,0-7.389,2.4-8.125,6.3A2.052,2.052,0,0,1,5.23,4.883a.5.5,0,0,0-.82-.313A6.916,6.916,0,0,0,2.025,10.7a5.76,5.76,0,0,0,1.943,3.638.25.25,0,0,0,.4-.114A8.506,8.506,0,0,1,12.477,8.251Z', 'M10.977 16.751 A1.500 1.500 0 1 0 13.977 16.751 A1.500 1.500 0 1 0 10.977 16.751 Z', 'M12.477,9.751a7,7,0,1,0,7,7A7,7,0,0,0,12.477,9.751Zm2.5,7a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,14.977,16.751Z']],
  CdRom: ['cd-rom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2,10.5H22a.5.5,0,0,0,.48-.641L20.111,1.754A3.076,3.076,0,0,0,17.247,0H6.753A3.068,3.068,0,0,0,3.884,1.775L1.52,9.86A.5.5,0,0,0,2,10.5Z', 'M20.5,12H3.5A2.5,2.5,0,0,0,1,14.5v2.254a2.5,2.5,0,0,0,2.5,2.5h.694a.252.252,0,0,0,.249-.276,5.441,5.441,0,0,1-.033-.587,4.7,4.7,0,0,1,.408-2.026.249.249,0,0,0-.224-.361H4.516a.75.75,0,1,1,0-1.5H19.5a.75.75,0,1,1,0,1.5h-.178a.249.249,0,0,0-.223.362,4.577,4.577,0,0,1,.4,1.989,5.785,5.785,0,0,1-.036.621.249.249,0,0,0,.249.278H20.5a2.5,2.5,0,0,0,2.5-2.5V14.5A2.5,2.5,0,0,0,20.5,12Z', 'M18,18.6a4.993,4.993,0,0,0-.687-2.47.249.249,0,0,0-.218-.127H6.819a.249.249,0,0,0-.218.128,5.124,5.124,0,0,0-.691,2.505C5.91,21.56,8.617,24,11.955,24S18,21.523,18,18.6Zm-6-1.847a2,2,0,1,1-2,2A2,2,0,0,1,12,16.755Z', 'M11.000 18.755 A1.000 1.000 0 1 0 13.000 18.755 A1.000 1.000 0 1 0 11.000 18.755 Z']]
};
exports["default"] = _default;